var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestDesktopLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 4c0-2.468 1.539-4 3.88-4s4.173 2.547 4.173 2.547S9.879 0 12.22 0 16 1.497 16 4s-4.478 6.743-7.95 9.5C4.583 10.743 0 6.468 0 4"
})));
export default SvgPinterestDesktopLike;